import {
  BUILDING_NUMBER_MESSAGE,
  BUILDING_NUMBER_PATTERN,
} from "../ValidFunction";

export const CHECKOUT_FIELD = {
  NAME: "name",
  PHONE: "phone",
  ADDRESS: "address",
  HOUSE: "house",
};

export const CHECKOUT_VALIDATION_CATEGORY = {
  PROFILE: "profile",
  ADDRESS: "address",
};

const trim = (value) => String(value ?? "").trim();

export function isValidCheckoutPhone(phone) {
  const digits = trim(phone).replace(/\D/g, "");
  if (!digits) return false;
  // Israeli mobile (05X-XXXXXXX) or common landline area codes.
  return /^05\d{8}$/.test(digits) || /^0(2|3|4|8|9)\d{7}$/.test(digits);
}

/**
 * Validates checkout personal details and shipping address before save/payment.
 * Returns { valid: true } or { valid: false, message, category, field }.
 */
export function validateCheckoutDetails(
  { firstName, lastName, phone, city, street, house, locationValidated },
  { requireAddress = true } = {},
) {
  if (!trim(firstName) || !trim(lastName)) {
    return {
      valid: false,
      message: "יש למלא שם פרטי ושם משפחה",
      category: CHECKOUT_VALIDATION_CATEGORY.PROFILE,
      field: CHECKOUT_FIELD.NAME,
    };
  }

  if (!trim(phone)) {
    return {
      valid: false,
      message: "יש למלא מספר טלפון",
      category: CHECKOUT_VALIDATION_CATEGORY.PROFILE,
      field: CHECKOUT_FIELD.PHONE,
    };
  }

  if (!isValidCheckoutPhone(phone)) {
    return {
      valid: false,
      message: "יש להזין מספר טלפון תקין",
      category: CHECKOUT_VALIDATION_CATEGORY.PROFILE,
      field: CHECKOUT_FIELD.PHONE,
    };
  }

  if (!requireAddress) {
    return { valid: true };
  }

  if (!locationValidated || !trim(city) || !trim(street)) {
    return {
      valid: false,
      message: "יש לבחור רחוב ועיר מתוך הרשימה",
      category: CHECKOUT_VALIDATION_CATEGORY.ADDRESS,
      field: CHECKOUT_FIELD.ADDRESS,
    };
  }

  if (!trim(house)) {
    return {
      valid: false,
      message: "יש למלא מספר בית",
      category: CHECKOUT_VALIDATION_CATEGORY.ADDRESS,
      field: CHECKOUT_FIELD.HOUSE,
    };
  }

  if (!BUILDING_NUMBER_PATTERN.test(trim(house))) {
    return {
      valid: false,
      message: BUILDING_NUMBER_MESSAGE,
      category: CHECKOUT_VALIDATION_CATEGORY.ADDRESS,
      field: CHECKOUT_FIELD.HOUSE,
    };
  }

  return { valid: true };
}
